/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var Icon360 = createReactComponent("360", "Icon360", [
  [
    "path",
    {
      d: "M17 15.328c2.414 -.718 4 -1.94 4 -3.328c0 -2.21 -4.03 -4 -9 -4s-9 1.79 -9 4s4.03 4 9 4",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 13l3 3l-3 3", key: "svg-1" }]
]);

export { Icon360 as default };
//# sourceMappingURL=Icon360.js.map
